/**
 * @deprecated Import `{ CustomScrollbar }` from `@ui/molecules/CustomScrollbar`.
 * This path re-exports the Quimby molecule so existing listing consumers keep working.
 */
import { CustomScrollbar } from '@ui/molecules/CustomScrollbar';

export default CustomScrollbar;
